import React, { FC } from 'react';
import classes from './ErrorFallback.module.scss';

type ErrorFallbackProps = {
  resetError: () => void;
};

const ErrorFallback: FC<ErrorFallbackProps> = ({ resetError }) => {
  const handleReload = () => {
    resetError();
    window.location.reload();
  };

  return (
    <div className={classes.container}>
      <p className={classes.message}>Произошла ошибка. Попробуйте обновить страницу.</p>
      <button type="button" className={classes.button} onClick={handleReload}>
        Обновить страницу
      </button>
    </div>
  );
};

export default ErrorFallback;
